module.exports = __webpack_public_path__ + "img/full4-min.4abc5abd.png";